<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M15.9346 12.4531L16.2012 12.9948C16.3346 13.2615 16.6762 13.5115 16.9596 13.5615L17.3179 13.6198C18.4096 13.8031 18.6596 14.6031 17.8846 15.3865L17.5512 15.7198C17.3262 15.9448 17.2096 16.3781 17.2762 16.6948L17.3179 16.8948C17.6179 18.2115 16.9179 18.7198 15.7762 18.0281L15.5346 17.8781C15.2429 17.7031 14.7596 17.7031 14.4679 17.8781L14.2262 18.0281C13.0762 18.7198 12.3846 18.2115 12.6846 16.8948L12.7262 16.6948C12.7929 16.3865 12.6762 15.9448 12.4512 15.7198L12.1179 15.3865C11.3429 14.5948 11.5929 13.8031 12.6846 13.6198L13.0429 13.5615C13.3346 13.5115 13.6679 13.2615 13.8012 12.9948L14.0679 12.4531C14.5846 11.4115 15.4179 11.4115 15.9346 12.4531Z"
      fill="currentColor"
    />
    <path
      d="M13.493 1.66797H6.50963C3.4763 1.66797 1.66797 3.4763 1.66797 6.50963V13.493C1.66797 16.5263 3.4763 18.3346 6.50963 18.3346H10.9096C11.2013 18.3346 11.4096 18.0346 11.3763 17.743C11.343 17.4263 11.3596 17.0513 11.4596 16.618C11.4763 16.5596 11.4596 16.493 11.4096 16.443L11.2263 16.2596C10.518 15.543 10.2596 14.6763 10.5096 13.8846C10.768 13.1013 11.4846 12.5513 12.4763 12.3846L12.7263 12.343L12.9513 11.893C13.4096 10.9596 14.1596 10.418 15.0013 10.418C15.843 10.418 16.593 10.9596 17.0513 11.893L17.1763 12.1513C17.2346 12.2763 17.3513 12.3596 17.4846 12.3846C17.5596 12.4013 17.6346 12.418 17.7096 12.4346C18.0013 12.5096 18.3346 12.2763 18.3346 11.968V6.50963C18.3346 3.4763 16.5263 1.66797 13.493 1.66797ZM13.5513 7.46797L11.6263 9.9513C11.3846 10.2596 11.043 10.4596 10.6513 10.5013C10.268 10.5513 9.8763 10.443 9.5763 10.2013L8.0513 9.01797C7.99297 8.96797 7.9263 8.96797 7.89297 8.9763C7.85963 8.9763 7.8013 8.99297 7.7513 9.05963L5.76797 11.6346C5.64297 11.793 5.45964 11.8763 5.26797 11.8763C5.13463 11.8763 5.0013 11.8346 4.88463 11.743C4.60964 11.5346 4.55963 11.143 4.76797 10.868L6.7513 8.29297C6.99297 7.98463 7.33463 7.78463 7.7263 7.73463C8.11797 7.68463 8.5013 7.79297 8.80963 8.03463L10.3346 9.23463C10.393 9.28463 10.4513 9.2763 10.493 9.2763C10.5263 9.2763 10.5846 9.25963 10.6346 9.19297L12.5596 6.70963C12.768 6.43463 13.1596 6.38463 13.4346 6.6013C13.718 6.80963 13.7596 7.2013 13.5513 7.46797Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TrendCollectionIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>